import { render } from "./CoverageView.vue?vue&type=template&id=2673c0f0&scoped=true"
import script from "./CoverageView.vue?vue&type=script&lang=js"
export * from "./CoverageView.vue?vue&type=script&lang=js"

import "./CoverageView.vue?vue&type=style&index=0&id=2673c0f0&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2673c0f0"]])

export default __exports__